import { NavLink } from 'react-router';
import { useT } from '@/state/useT';
import { HomeIcon, ReportIcon } from './Icons';
import { MasjidRoof } from './Masjid';

const linkClass = ({ isActive }: { isActive: boolean }) => `navb${isActive ? ' on' : ''}`;

export function TabBar() {
  const { t } = useT();

  return (
    <nav className="nav has-roof" aria-label={t('nav.label')}>
      <MasjidRoof />
      <NavLink to="/" className={linkClass} end>
        <HomeIcon />
        <span>{t('nav.home')}</span>
      </NavLink>
      {/* No Log tab. Recording is not a place you go — it is a sheet that
          comes up over a prayer, from its row on Home or its cell in the
          report, and goes back down again. A tab for it put a permanent
          destination in the bar for something that has no screen of its own. */}
      <NavLink to="/report" className={linkClass}>
        <ReportIcon />
        <span>{t('nav.report')}</span>
      </NavLink>
    </nav>
  );
}
